/**
 * #2712 CLIENTERROR: main.tsx imports this module FIRST, so the window error
 * listeners are in place before App's import graph evaluates. An exception
 * thrown while a module that App imports is being evaluated (the deploy
 * break the reporter exists to see) reaches the server too.
 */
import { installClientErrorReporting } from "./lib/client-error-report";

installClientErrorReporting();
